import React from "react"

export default (name, value) => {
  const Context = React.createContext(value)
  Context.Provider.displayName = `${name}.Provider`
  Context.Consumer.displayName = `${name}.Consumer`
  return Context
}
